import { DateTime } from 'luxon';
import { Pagination, paginationToParams } from '../Pagination';

export interface PlatformOrderFilter {
  id?: string;
  customerName?: string;
  cargoTrackingNumber?: string;
  startAt?: Date;
  endAt?: Date;
  pagination: Pagination;
}

export const getDefaultPlatformOrderFilter = (): PlatformOrderFilter => ({
  pagination: {
    page: 0,
    pageSize: 10,
  },
});

export const platformOrderFilterToQueryParams = (
  filter: PlatformOrderFilter,
) => ({
  id: filter.id ? Number(filter.id) : undefined,
  'customer-name': filter.customerName || undefined,
  'cargo-tracking-number': filter.cargoTrackingNumber || undefined,
  'start-at': filter.startAt
    ? DateTime.fromJSDate(filter.startAt).toISO()
    : undefined,
  'end-at': filter.endAt
    ? DateTime.fromJSDate(filter.endAt).toISO()
    : undefined,
  ...paginationToParams(filter.pagination),
});
